import React, { useState } from 'react'
import GoogleIcon from './GoogleIcon'
import styles from './login.module.scss'

const LoginForm = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const handleGoogleLogin = () => {
        // Later this would redirect to Cognito / Google OAuth
    }

    return (
        <form className={styles.loginForm}>
            <div style={{ marginBottom: '1rem' }} className={styles.inputGroup}>
                <label
                    htmlFor="username"
                    className={username ? styles.activeLabel : ''}
                >
                    Email
                </label>

                <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
            </div>

            <div className={styles.inputGroup}>
                <label
                    htmlFor="password"
                    className={password ? styles.activeLabel : ''}
                >
                    Password
                </label>

                <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>

            <div className={styles.forgot}>Forgot Password?</div>

            <button type="submit" className={styles.submitButton}>
                Login
            </button>

            <div className={styles.divider}>
                <span>or</span>
            </div>

            <button
                type="button"
                className={styles.googleButton}
                onClick={handleGoogleLogin}
            >
                <GoogleIcon />
                <span>Continue with Google</span>
            </button>
        </form>
    )
}

export default LoginForm
